export const resumoNomes = (itens, vazio = 'Todos') => {
  const nomes = (itens || []).map((item) => item?.nome || item?.descricao).filter(Boolean);
  return nomes.length ? nomes.join(', ') : vazio;
};
